import { render, staticRenderFns } from "./BlogRouter.vue?vue&type=template&id=31fbb175&scoped=true&"
import script from "./BlogRouter.vue?vue&type=script&lang=js&"
export * from "./BlogRouter.vue?vue&type=script&lang=js&"
import style0 from "./BlogRouter.vue?vue&type=style&index=0&id=31fbb175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fbb175",
  null
  
)

export default component.exports